import { Form, Formik } from "formik";
import { ScrollToFirstError } from "@components/common";
import { withFormikDevtools } from "formik-devtools-extension";
import { getLandingSchema } from "@product-pages/model/validation/schemas/objects/landing";
import { LandingSummary } from "./landingSummary";
import { useState } from "react";
import { initialValues } from "./initial-values";
import LandingForm from "./landingForm";

const LandingPage: React.FC<any> = () => {
    const [showCarSectionForm, setShowCarSectionForm] = useState<boolean>(true);
    return (
        <>
            <Formik
                initialValues={initialValues()}
                onSubmit={() => { }}
                enableReinitialize
                validateOnMount
                validateOnChange
                validationSchema={getLandingSchema()}
            >
                {(formikProps) => {
                    // Enable Formik Developer Tools
                    if (process.env.NODE_ENV === "development") {
                        withFormikDevtools(formikProps);
                    }

                    return (
                        <Form noValidate >
                            {showCarSectionForm ? <>
                                <LandingForm setShowCarSectionForm={setShowCarSectionForm} formikProps={formikProps} />
                            </> : <>
                                <LandingSummary setShowCarSectionForm={setShowCarSectionForm} values={formikProps.values} />
                            </>}
                            <ScrollToFirstError />
                        </Form>
                    );
                }}
            </Formik>
        </>
    );
};

export default LandingPage